import { LayoutDashboard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const OpenInAdmin = ({ orderNumber, size = "md", className = "" }) => {
  const { user } = useAuth();
  if (user?.role !== "admin" || !orderNumber) return null;
  const sm = size === "sm";
  return (
    <a href={`/admin?tab=orders&order=${encodeURIComponent(orderNumber)}`} data-testid={`open-in-admin-${orderNumber}`}
      className={`inline-flex items-center gap-1.5 rounded-full bg-[#22c3d6] text-black font-semibold hover:bg-[#4fd8e8] transition-colors ${sm ? "h-7 px-2.5 text-xs" : "h-9 px-4 text-sm"} ${className}`}>
      <LayoutDashboard size={sm ? 12 : 14} />Open in Admin
    </a>
  );
};
